import { render, staticRenderFns } from "./teacherDialog.vue?vue&type=template&id=2d293278&scoped=true"
import script from "./teacherDialog.vue?vue&type=script&lang=js"
export * from "./teacherDialog.vue?vue&type=script&lang=js"
import style0 from "./teacherDialog.vue?vue&type=style&index=0&id=2d293278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d293278",
  null
  
)

export default component.exports